/**
 * /moniteur/progression — Stats agrégées sur les élèves du moniteur.
 */
import React from 'react';
import { TrendingUp, Calendar, Users, Award } from 'lucide-react';

export default function MoniteurProgressionPage() {
  return (
    <div className="max-w-5xl" data-testid="moniteur-progression-page">
      <div className="text-[10.5px] font-black uppercase tracking-[0.22em] text-rose-500 mb-2">Suivi pédagogique</div>
      <h1 className="text-4xl sm:text-5xl font-black text-white tracking-tight" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>Progression</h1>
      <p className="text-sm text-white/60 mt-2 mb-6">Suivi consolidé de la progression de tes élèves. Enrichissement en Phase 30b.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {[
          { icon: Users, label: 'Nombre d’élèves suivis', desc: 'Total des élèves à ta charge sur les 3 derniers mois', color: '#f43f5e' },
          { icon: Calendar, label: 'Leçons données', desc: 'Volume horaire d’enseignement dispensé', color: '#0ea5e9' },
          { icon: Award, label: 'Compétences REMC validées', desc: 'Nombre de compétences passées OK dans tes bilans', color: '#10b981' },
          { icon: TrendingUp, label: 'Note progression moyenne', desc: 'Moyenne des progressions données à tes élèves', color: '#f59e0b' },
        ].map((k, i) => (
          <div key={i} className="rounded-2xl border border-white/10 bg-white/[0.02] p-5" data-testid={`progression-metric-${i}`}>
            <div className="w-10 h-10 rounded-lg flex items-center justify-center mb-3" style={{ background: `${k.color}22`, color: k.color }}>
              <k.icon className="w-5 h-5" />
            </div>
            <div className="text-3xl font-black text-white/40" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>—</div>
            <div className="text-sm text-white font-semibold mt-1">{k.label}</div>
            <div className="text-xs text-white/50 mt-1">{k.desc}</div>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-lg border border-blue-500/25 bg-blue-500/5 p-4 text-xs text-blue-200/80">
        <strong className="text-blue-300">Bientôt :</strong> graphique d’évolution mois par mois + heat-map des compétences.
      </div>
    </div>
  );
}
